import { NgModule, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// components
import { LogoutComponent } from '../../../../../coverpath-common/angular/components/logout/logout.component';

// services
import { AuthenticationService } from '../../../../../coverpath-common/angular/services/authentication/authentication.service';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { BaseLoginService } from '../../../../../coverpath-common/angular/services/login/base-login.service';
import { LoginService } from '../../services/login/login.service';
import { ValidationService } from '../../../../../coverpath-common/angular/services/validation/validation.service';
import { FormatterService } from '../../../../../coverpath-common/angular/services/formatter/formatter.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';

// modules
import { authenticationServiceFactory } from '../../../../../coverpath-common/angular/services/authentication/authentication.service.provider';
import { CoverpathAuth0Service } from '../../services/authentication/coverpath-auth0.service';
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../../../coverpath-common/angular/components/shared/spinner/spinner.module';

import { CoverpathLogoutComponent } from './coverpath-logout.component';

@NgModule({
  declarations: [LogoutComponent, CoverpathLogoutComponent],
  imports: [SharedModule, LoadingModule, SpinnerModule],
  exports: [LogoutComponent, CoverpathLogoutComponent],
  providers: [
    AmorphicService,
    BaseLoginService,
    LoginService,
    ValidationService,
    FormatterService,
    WindowService,
    {
      provide: AuthenticationService,
      useFactory: authenticationServiceFactory,
      deps: [WindowService, ActivatedRoute, Router, AmorphicService, CoverpathAuth0Service, LoginService],
    },
  ],
  bootstrap: [LogoutComponent, CoverpathLogoutComponent],
})
export class LogoutModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    LogoutModule.injector = injector;
  }
}
